module.exports = __webpack_public_path__ + "media/images/kvimg_1sp-d8d09c8e4e6cb0ba585257742f9f1369.jpg";